/* eslint-disable */
import { Button, Message, Icon, Card, Segment, Checkbox, Dropdown, Input, Pagination } from 'semantic-ui-react';
import { useState, useContext, useEffect }                                             from 'react';
import { useDebounce }                                                                 from 'use-debounce';
import styled                                                                          from 'styled-components';
import AppContext                                                                      from '../../../context/HeaderContext';
import Duration                                                                        from '../../../components/Duration';
import { getAPI }                                                                      from '../../../libs/fetchAPI';
import PassFailResult                                                                  from '../../../components/PassFailResult';
import JiraLink                                                                        from '../../../components/JiraLink';
import Loading                                                                         from '../../../components/Loading';

const CustomCardItem = styled.span`
	&:not(:first-child) {
		margin-right: 25px;
	}
`;

const CustomFormItem = styled.span`
	margin-right: 25px;
`;

const CustomWidthInput = styled(Input)`
	min-width: 400px !important;
`;

const CustomSegment = styled(Segment)`
	padding: 1.5em 1em !important;
`;

const FilterHeader = styled.span`
	font-weight: bold;
	color: grey;
	margin-left: 5px;
	font-size: 1.2em;
	fong-family: Lato,'Helvetica Neue',Arial,Helvetica,sans-serif;
`;

const CustomMessage = styled(Message)`
	text-align: center;
`;

function Runs({ handleSetName }) {
	const { current_project_id }                          = useContext(AppContext);
	const [ loading, setLoading ]                         = useState(true);
	const [ test_runs, setTestRuns ]                      = useState([]);
	const [ page_count, setPageCount ]                    = useState(1);
	const [ page_index, setPageIndex ]                    = useState(1);
	const [ date_range, setDateRange ]                    = useState(`7 day`);
	const [ search, setSearch ]                           = useState(``);
	const [ report_users, setReportUsers ]                = useState([]);
	const [ report_suites, setReportSuites ]              = useState([]);
	const [ report_passed, setReportPassed ]              = useState(true);
	const [ report_failed, setReportFailed ]              = useState(true);
	const [ report_user_options, setReportUserOptions ]   = useState([]);
	const [ report_suite_options, setReportSuiteOptions ] = useState([]);
	const [ debounced_search ]                            = useDebounce(search, 500);

	handleSetName(``);

	useEffect(() => {
		fetchReportOptions();
		fetchData();
	}, [current_project_id, date_range, report_users, report_suites, report_passed, report_failed, debounced_search, page_index]);

	const fetchReportOptions = () => {
		const params = {
			project_id : current_project_id,
		};
		getAPI(`/runs/report_options?${new URLSearchParams(params).toString()}`)
			.then((data) => {
				setReportUserOptions(data.users.map(user => ({ key: user, value: user, text: user })));
				setReportSuiteOptions(data.suites.map(suite => ({ key: suite, value: suite, text: suite })));
			});
	}

	const fetchData = () => {
		const sort_key       = `run_date`;
		const sort_direction = `DESC`;
		const page_size      = 30;

		const params =  {
			project_id  : current_project_id,
			limit       : page_size,
			offset      : page_size * (page_index - 1),
			sort_key,
			sort_direction,
			date_range,
			report_users,
			report_suites,
			report_passed,
			report_failed,
			search: debounced_search,
		};

		setLoading(true);
		getAPI(`/runs?${new URLSearchParams(params).toString()}`)
			.then((data) => {
				setPageCount(data.pages);
				setTestRuns(data.data ?? []);

				setLoading(false);
			});
	}

	const date_options = [
		{
			key   : `7d`,
			text  : `Last 7 days`,
			value : `7 day`,
		},
		{
			key   : `30d`,
			text  : `Last 30 days`,
			value : `30 day`,
		},
		{
			key   : `60d`,
			text  : `Last 60 days`,
			value : `60 day`,
		},
		{
			key   : `90d`,
			text  : `Last 90 days`,
			value : `90 day`,
		},
		{
			key   : `180d`,
			text  : `Last 180 days`,
			value : `180 day`,
		}
	];

	function handleReportChange(value, fn) {
		fn(value);
	}

	function hadlePageChange(active_page) {
		setPageIndex(active_page);
	}

	return (
		<>
			<CustomSegment>
				<div>
					<Icon name="filter" color="grey" />
					<FilterHeader>Filter</FilterHeader>
				</div>

				<br></br>
				<div>
					<CustomFormItem>
						<Dropdown
							placeholder='Date Range'
							selection
							onChange={(e, data) => handleReportChange(data.value, setDateRange)}
							options={date_options}
							value={date_range}
						/>
					</CustomFormItem>

					<CustomFormItem>
						<CustomWidthInput
							placeholder="Title, Build Key, Issue Key, etc."
							onChange={(e, data) => handleReportChange(data.value, setSearch)}
							value={search}
						/>
					</CustomFormItem>
				</div>
				<br></br>
				<div>
					<CustomFormItem>
						<Dropdown
							placeholder='Users'
							selection
							multiple
							search
							value={report_users}
							onChange={(e, data) => handleReportChange(data.value, setReportUsers)}
							options={report_user_options}
						/>
					</CustomFormItem>


					<CustomFormItem>
						<Dropdown
							placeholder="Suites"
							multiple
							search
							selection
							clearable
							value={report_suites}
							onChange={(e, data) => handleReportChange(data.value, setReportSuites)}
							options={report_suite_options}
						/>
					</CustomFormItem>

					<CustomFormItem>
						<Checkbox
							label="Passed"
							defaultChecked
							onChange={(e, data) => handleReportChange(data.checked, setReportPassed)}
						/>
					</CustomFormItem>

					<CustomFormItem>
						<Checkbox
							label="Failed"
							defaultChecked
							onChange={(e, data) => handleReportChange(data.checked, setReportFailed)}
						/>
					</CustomFormItem>
				</div>
			</CustomSegment>

			{loading ? <Loading /> : (
				<>
					<RunCards runs={test_runs} />
					{!test_runs.length ? null : (
						<Pagination
							activePage={page_index}
							ellipsisItem={undefined}
							firstItem={undefined}
							lastItem={undefined}
							totalPages={page_count}
							fluid
							onPageChange={(e, data) => hadlePageChange(data.activePage)}
						/>
					)}
				</>
			)}
		</>
	);
}

function RunCards({ runs }) {
	if(!runs.length) {
		return (
			<CustomMessage info>
				You don't have any test runs yet. See the <a style={{fontWeight: `bold`, fontStyle: `italic`}} href="/docs">documentation</a> to get started.
			</CustomMessage>
		);
	}

	return runs.map((run) => {
		const run_url = `${window.location.origin}/runs/${run.id}`;

		return (
			<Card fluid key={run.id}>
				<Card.Content>
					{run.title ? (
						<Card.Header>
							<JiraLink issue_key={run.title} />

							<a href={run_url}><Button color="blue" floated="right">View</Button></a>
						</Card.Header>
					) : null}

					{run.issue_summary ? (
						<Card.Description>
							<a href={run_url}>
								{run.issue_summary}
							</a>
						</Card.Description>
					) : null}
				</Card.Content>

				<Card.Content extra>
					<CustomCardItem>
						<PassFailResult passed={run.passed} skipped={run.skipped} center={false} />
					</CustomCardItem>

					<CustomCardItem>
						<Icon name="calendar alternate outline" />
						<span>{new Date(`${run.run_date} UTC`).toLocaleString(`en-US`, {
							month  : `2-digit`,
							day    : `2-digit`,
							hour   : `2-digit`,
							minute : `2-digit`,
							hour12 : true,
						})}</span>
					</CustomCardItem>

					<CustomCardItem>
						<Icon name="clock outline" />
						<Duration duration={run.duration} />
					</CustomCardItem>

					<CustomCardItem>
						<Icon name="user" />
						<span>{run.issue_user}</span>
					</CustomCardItem>

					<CustomCardItem>
						<Icon name="code branch" />
						{run.version ? <span>{run.version}</span> : null}
					</CustomCardItem>
				</Card.Content>

				<Card.Content extra>
					<span>{run.total_passed ?? 0} / {run.total_failed ?? 0}</span>
				</Card.Content>

				{run.suites_ran ? (
					<Card.Content extra>
						<span>{run.suites_ran}</span>
					</Card.Content>
				) : null}
			</Card>
		);
	});
}

export default Runs;
